import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=7ff7fc56&scoped=true"
import script from "./roleEdit.vue?vue&type=script&lang=js"
export * from "./roleEdit.vue?vue&type=script&lang=js"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=7ff7fc56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff7fc56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff7fc56')) {
      api.createRecord('7ff7fc56', component.options)
    } else {
      api.reload('7ff7fc56', component.options)
    }
    module.hot.accept("./roleEdit.vue?vue&type=template&id=7ff7fc56&scoped=true", function () {
      api.rerender('7ff7fc56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roleEdit.vue"
export default component.exports